<template>
  <div v-if="testData" class="flex flex-col">
    <TeacherTitleSlug
      v-if="false"
      :title="testData.title"
      :highlight-title="highlight.title"
      :highlight-paragraph="highlightParagraph"
      :link-for-back="`/teacher/${$route.params.parent}/${$route.params.category}?content=${testData.model_type}${groupList}`"
    />
    <template v-if="testState === 'ready'">
      <CommonBlocksImageArticleBlock
        v-if="testData?.image"
        class="test-cardimage mb-[32px]"
        is-social
        is-teacher-test
        :data="testData"
        :published-at="testData?.published_at"
        :src="testData?.image.src"
        ><template v-if="isDesktop && testState === 'ready'" #teacher-button>
          <div
            class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
          >
            <BaseTheButtonNew
              text="Пройти тест"
              type="transparent--black"
              @click="handleStartTest"
            />
          </div> </template
      ></CommonBlocksImageArticleBlock>
      <div class="text-[18px] leading-[28px]">
        <div v-html="testData.description"></div>
      </div>
    </template>

    <div ref="testWrapperRef" class="flex flex-col xl:flex-row">
      <template
        v-if="
          isTestInProgress ||
          (isNotDesktop && ['ready', 'proceed'].includes(testState))
        "
      >
        <div
          class="flex flex-col rounded-[12px] bg-white-100 p-4 pb-5 shadow-drop-0 xl:mr-5 xl:w-3/4 xl:px-12 xl:pb-12 xl:pt-13 2xl:w-4/5"
          :class="{ 'mask-mob': testState === 'ready' }"
        >
          <div class="flex flex-col">
            <div
              v-if="getCurrentQuestion?.image"
              class="mb-12 mr-8 h-[364px] w-full max-w-[548px] overflow-hidden rounded-xl"
            >
              <img
                v-lazy-load
                :src="getCurrentQuestion?.image?.src"
                alt=""
                class="h-inherit w-full object-cover"
              />
            </div>
            <div
              class="mb-[24px] flex-1 whitespace-pre-wrap text-[16px] font-bold leading-[20px] text-new-test-black lg:leading-[34px] xl:mb-[44px] xl:text-[24px]"
              v-html="getCurrentQuestion?.text"
            ></div>
          </div>
          <div
            class="flex flex-col pl-1 xl:flex-row xl:flex-wrap xl:pl-[initial]"
          >
            <TestsAnswerOptionButton
              v-for="(answer, idx) in getCurrentQuestion?.answer"
              :key="`test-answer-${answer.id}`"
              v-model:currently-checked-id="currentAnswerId"
              :data="answer"
              :update-question-answered="updatedCurrentQuestion?.count_answered"
              :count-question-answer="
                updatedCurrentQuestion?.answer?.[idx].count_answered
              "
              :disabled="!!currentAnswerId || testState === 'finished'"
              class="my-1.5 xl:mb-6"
              :class="{
                'lg:w-1/2': testData.view_type === 1,
                'lg:w-full': testData.view_type === 2,
              }"
              @update-count-answer="
                handleCountAnswers(getCurrentQuestion.id, answer.id)
              "
            />
          </div>

          <TestsAnswerDescription :answer="getCurrentAnswer" />

          <div class="flex items-center justify-between">
            <button
              v-if="
                isDesktop &&
                isTestInProgress &&
                !(isLastQuestion && updatedCurrentQuestion)
              "
              type="button"
              class="mr-5 mt-1.5 py-2 text-[14px] font-medium leading-[17px] text-black-56 transition-colors hover:text-black-100"
              @click="handleFinishTest"
            >
              Завершить тест
            </button>
            <BaseTheButtonNew
              v-show="
                !!updatedCurrentQuestion && (!isLastQuestion || isDesktop)
              "
              class="ml-auto mt-1.5 normal-case"
              :text="isLastQuestion ? 'Завершить тест' : 'Следующий вопрос'"
              type="secondary"
              :icon="
                !isNotDesktop && !isLastQuestion ? 'arrow-right-circle' : ''
              "
              is-small
              @click="handleNextQuestion(false)"
            />
            <BaseTheButtonNew
              v-show="!updatedCurrentQuestion"
              class="ml-auto mt-1.5 normal-case"
              type="default"
              text="Пропустить вопрос"
              is-small
              @click="handleNextQuestion(false)"
            />
          </div>

          <div class="mt-6 border-t border-[#F3F3F3] pt-5 xl:hidden">
            <TestsTestProgressBlock
              v-if="isNotDesktop"
              :question="{
                current: currentQuestionIndex,
                total: questions.length,
              }"
              :test-state="testState"
              :total-test-time="testData.time"
              @time-is-left="handleNextQuestion(true)"
            />
          </div>
        </div>
        <!-- <div v-if="getCurrentQuestion.image">
            <img :src="getCurrentQuestion.image.src" alt="" />
          </div> -->
      </template>

      <template v-else-if="testState === 'finished'">
        <div
          class="flex flex-col rounded-[12px] bg-white-100 p-4 pb-5 shadow-drop-0 xl:mr-5 xl:w-3/4 xl:px-12 xl:pb-12 xl:pt-13 2xl:w-4/5"
        >
          <div class="flex h-full flex-col">
            <div class="xl:mb-[106px]">
              <p>{{ testResults.title }}</p>
              <p>{{ testResults.text }}</p>
            </div>
            <template v-if="Object.keys(testResults)?.length">
              <div
                v-if="!isSuccessTest"
                class="mx-auto my-[12vh] flex w-fit items-center text-ruby-red-100 xl:my-[initial]"
              >
                <SvgIcon
                  name="failed-filled"
                  width="64"
                  height="64"
                  class="icon-reset"
                />
                <span class="ml-5 text-[24px] font-bold">Тест не пройден</span>
              </div>
              <div
                v-else
                class="mx-auto my-[12vh] flex w-fit items-center text-correct xl:my-[initial]"
              >
                <SvgIcon
                  name="success-filled"
                  width="64"
                  height="64"
                  class="icon-reset"
                />
                <span class="ml-5 text-[24px] font-bold">Успех!</span>
              </div>
            </template>
            <BaseTheButtonNew
              v-if="isDesktop && testState === 'finished'"
              class="ml-auto mt-auto normal-case"
              text="Пройти заново"
              is-small
              @click="handleResetTest"
            />
          </div>
          <div class="mt-auto flex justify-between">
            <BaseTheButtonNew
              v-if="
                testState !== 'finished' && (!!currentAnswerId || isNotDesktop)
              "
              class="mt-1.5 lg:mt-auto"
              text="Следующий вопрос"
              type="default"
              :icon="!isNotDesktop ? 'arrow-right-circle' : ''"
              is-small
              :disabled="
                (!isNotDesktop && !!isLastQuestion) ||
                (isNotDesktop && testState === 'finished')
              "
              @click="handleNextQuestion(false)"
            />
            <BaseTheButtonNew
              class="ml-4 mt-1.5 xl:hidden"
              type="secondary--disabled"
              text="пропустить"
              is-small
              disabled
            />
          </div>
        </div>
      </template>

      <div v-if="isNotDesktop">
        <template v-if="testState === 'ready'">
          <div class="mt-4 flex xl:mt-14">
            <div class="w-full xl:w-1/3">
              <BaseTheButtonNew
                class="mx-auto"
                text="Пройти тест"
                type="secondary"
                @click="handleStartTest"
              />
            </div>
          </div>
        </template>
        <template v-else-if="isTestInProgress">
          <div class="mt-4 flex xl:mt-14">
            <div class="w-full xl:w-1/3">
              <BaseTheButtonNew
                key="default"
                class="mx-auto"
                text="Завершить тест"
                type="default"
                @click="handleFinishTest"
              />
            </div>
          </div>
        </template>
        <template v-else-if="testState === 'finished'">
          <div class="flex">
            <div class="mt-4 w-full xl:mt-14 xl:w-1/3">
              <BaseTheButtonNew
                class="mx-auto"
                text="Пройти заново"
                @click="handleResetTest"
              />
            </div>
          </div>
        </template>
      </div>

      <div
        v-if="testState !== 'ready' && isNotMobile"
        class="col-span-3 col-start-10 hidden h-full xl:block xl:w-1/4 2xl:w-1/5"
      >
        <div class="rounded-[12px] bg-white-100 px-6 pb-11 pt-7 shadow-drop-0">
          <TestsTestProgressBlock
            v-if="!isNotDesktop"
            :question="{
              current: currentQuestionIndex,
              total: questions.length,
              isSuccessTest: isSuccessTest,
            }"
            is-teacher-test
            :test-state="testState"
            :total-test-time="testData.time"
            :current-answer-id="currentAnswerId"
            @time-is-left="handleNextQuestion(true)"
            @on-miss-question-click="handleNextQuestion(false)"
            @handle-reset-test="handleResetTest()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import api from '@/services/api/api';

definePageMeta({
  layout: 'marginless',
});

const crumbsStore = useBreadcrumbsStore();
const modalsStore = useModalsStore();

const props = defineProps({
  highlight: {
    type: Object,
    default: () => ({}),
  },
  category: {
    type: Object,
    default: () => ({}),
  },
});

const { isDesktop, isNotDesktop, isNotMobile } = useBreakpoint();
const route = useRoute();
const slug = route?.params?.slug;
const { testSlug } = useTestBySlug(slug);
useErrorHandler(() => testSlug.failureReason.value?.status);

const testData = computed(() => testSlug?.data?.value);
const questions = computed(() => testSlug?.data?.value?.questions || []);

const testState = ref('ready');
const currentQuestionIndex = ref(0);
const currentAnswerId = ref(null);
const goResult = ref(false);
const rightAnswers = ref(0);
const points = ref(0);
const testResults = ref({});
const updatedCurrentQuestion = ref(null);
const testWrapperRef = ref(null);

/**computed */
const groupList = computed(() => {
  if (!route?.query?.group) return '';
  return `&group=${route.query.group}`;
});

const highlightParagraph = computed(() => {
  let highlightIdx;
  props.category.chapters.find((item) =>
    item.highlights.find((highlight) => {
      if (highlight.id !== props.highlight.id) return '';
      highlightIdx = highlight.number;
      return highlight;
    }),
  );
  return highlightIdx ? `§ ${highlightIdx}.` : '';
});

const getCurrentQuestion = computed(() => {
  return questions.value[currentQuestionIndex.value];
});

const getCurrentAnswer = computed(() => {
  return getCurrentQuestion.value?.answer?.find(
    (el) => el.id === currentAnswerId.value,
  );
});

const isLastQuestion = computed(() => {
  return currentQuestionIndex.value === questions.value?.length - 1;
});

const isTestInProgress = computed(() => {
  return testState.value === 'proceed';
});

// const questionsCount = computed(() => {
//   return questions.value?.length;
// });

const isSuccessTest = computed(() => {
  return testResults.value?.lowest_value > 0;
});

/**watch */
watch(
  () => currentAnswerId.value,
  (newValue, oldValue) => {
    if (newValue && !oldValue) {
      if (getCurrentAnswer.value?.is_right) {
        rightAnswers.value++;
        if (getCurrentAnswer.value?.points) {
          points.value += getCurrentAnswer.value?.points;
        }
      }

      if (!!isLastQuestion.value && !!currentAnswerId.value) {
        goResult.value = true;
      }
    }
  },
);

watch(
  testData,
  (val) => {
    if (!val) return;
    crumbsStore.setCrumbs({
      key: 'slug',
      value: {
        title: testData.value?.title,
        slug: testData.value?.slug,
      },
    });
  },
  { immediate: true },
);

onBeforeRouteLeave(() => {
  crumbsStore.setCrumbs({ key: 'slug', value: null });
});

/**methods */
const finishTest = () => {
  if (!isTestInProgress.value) return;
  testState.value = 'finished';
  loadResults();
};

const handleFinishTest = () => {
  if (isLastQuestion.value && currentAnswerId.value) {
    finishTest();
    return;
  }
  modalsStore.showLessonConfirm({
    title: 'Завершить тест?',
    text: 'Оставшиеся вопросы не будут засчитаны. Продолжить тест с этого места потом не получится.',
    confirmText: 'Завершить',
    onConfirm: finishTest,
  });
};

const handleNextQuestion = (isTimeLeft = false) => {
  updatedCurrentQuestion.value = null;
  if (isLastQuestion.value || isTimeLeft) {
    testState.value = 'finished';
    loadResults();
  } else {
    currentAnswerId.value = null;
    currentQuestionIndex.value++;
  }
  const top =
    window.scrollY + testWrapperRef.value.getBoundingClientRect().y - 184; // 184 - отступ header + кнопка
  window.scroll(0, top);
};

const handleResetTest = () => {
  testState.value = 'ready';
  currentQuestionIndex.value = 0;
  currentAnswerId.value = null;
  updatedCurrentQuestion.value = null;
  rightAnswers.value = 0;
  points.value = 0;
  window.scroll(0, 0);
};

const handleStartTest = () => {
  testState.value = 'proceed';
  const top =
    window.scrollY + testWrapperRef.value.getBoundingClientRect().y - 184; // 184 - отступ header + кнопка
  window.scroll(0, top);
};

const handleCountAnswers = async (questionId, answerId) => {
  try {
    const { data } = await api.tests.updateCountAnswers(questionId, answerId);
    updatedCurrentQuestion.value = data.data;
  } catch (e) {
    console.log(e);
  }
};

const loadResults = async () => {
  const testStats = {
    count: rightAnswers.value,
    points: points.value,
  };

  try {
    const { data } = await api.tests.loadTestResults(slug, testStats);
    testResults.value = data;
  } catch (e) {
    console.log(e);
  }
};

useHead(
  computed(() => ({
    title: `${
      testData.value?.title ? `${testData.value.title} |` : ''
    } Материалы по истории для школьного курса «История России» и «Всеобщая история» с 5 по 11 класс`,
    meta: [
      {
        name: 'description',
        content:
          'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: `${useHostApp()}${testData.value?.image?.src}` || '',
      },
      {
        hid: 'og:type',
        property: 'og:type',
        content: 'article',
      },
      {
        property: 'og:title',
        content: `${
          testData.value?.title ? `${testData.value.title} |` : ''
        } Материалы по истории для школьного курса «История России» и «Всеобщая история» с 5 по 11 класс`,
      },
      {
        property: 'og:url',
        content: `${useHostApp()}${route.path}`,
      },
      {
        property: 'og:description',
        content:
          'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href:
          `${useHostApp()}/tests/${testData.value?.id}` ||
          `${useHostApp()}${route.path}`,
      },
    ],
  })),
);
</script>

<style scoped>
.highlight {
  -webkit-tap-highlight-color: #0000;
}
.mask-mob {
  @apply relative;
  @apply before:absolute before:inset-0 before:bg-[#ffffff7a] before:z-10 pointer-events-none;
}
</style>
